import { apiFetch, isErrorResult } from "../../../../app/apiClient.js";
import { updateFilterOptions } from "../utils/filterManager.js";
import { toast } from "../../../layout/app-toast/utils/toastManager.js";
import { validateData, getContent, removeStaleRow, deleteRecord } from "./tableManager.js";
import { currentTable } from "../../../../app/viewManager.js";

async function collectData() {
    const content = getContent();
    if (!content) return null;
    return {
        Name:        content.querySelector("#inputServiceName")?.getValue?.()        ?? "",
        Description: content.querySelector("#inputServiceDescription")?.getValue?.() ?? "",
        Url:         content.querySelector("#inputServiceUrl")?.getValue?.()         ?? "",
    };
}

function toRowData(service) {
    return {
        id:          service.id,
        name:        service.name,
        description: service.description ?? "",
        url:         service.url ?? "",
    };
}

function sortByName() { currentTable.setSort("name", "asc"); }

export async function loadServices() {
    const services = await apiFetch("Services");
    currentTable.options.placeholder = "Keine Daten vorhanden";
    if (!Array.isArray(services)) { currentTable.replaceData([]); return; }

    const serviceData = services.map(toRowData);
    currentTable.setData(serviceData);
    sortByName();
    updateFilterOptions(serviceData, currentTable);
}

export async function createService() {
    const collectedData = await collectData();
    if (!collectedData) return;

    const missingFields = await validateData(collectedData);
    if (missingFields.length > 0) return true;

    const newService = await apiFetch("Services", "POST", {
        Name:        collectedData.Name,
        Description: collectedData.Description,
        Url:         collectedData.Url,
    });
    if (isErrorResult(newService)) return newService ? true : undefined;

    await currentTable.addRow(toRowData(newService), true);
    sortByName();
    updateFilterOptions(currentTable.getData(), currentTable);
    toast("Service erfolgreich hinzugefügt!", "success");
    return newService;
}

export async function updateService(serviceId) {
    const collectedData = await collectData();
    if (!collectedData) return;

    const missingFields = await validateData(collectedData);
    if (missingFields.length > 0) return true;

    const updatedService = await apiFetch(`Services/${serviceId}`, "PATCH", {
        Name:        collectedData.Name,
        Description: collectedData.Description,
        Url:         collectedData.Url,
    });

    if (removeStaleRow(updatedService, serviceId)) return;
    if (isErrorResult(updatedService)) return updatedService ? true : undefined;

    await currentTable.updateOrAddData([toRowData(updatedService)]);
    sortByName();
    updateFilterOptions(currentTable.getData(), currentTable);
    toast("Service erfolgreich aktualisiert!", "success");
    return updatedService;
}

export const deleteService = (serviceId) => deleteRecord("Services", serviceId, "Service erfolgreich gelöscht!");
